export default {
  common: {
    welcome: 'Bienvenido',
    loading: 'Cargando...',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    create: 'Crear',
    search: 'Buscar',
    close: 'Cerrar',
    confirm: 'Confirmar',
    back: 'Volver',
    next: 'Siguiente',
    previous: 'Anterior',
    actions: 'Acciones',
    status: 'Estado',
    active: 'Activo',
    inactive: 'Inactivo',
    yes: 'Sí',
    no: 'No',
    id: 'ID',
    created_at: 'Creado en',
    noDescription: 'Sin descripción',
    rowsPerPage: 'Filas por página:',
    noResults: 'No se encontraron resultados',
    noData: 'No hay datos registrados',
    unknown: 'Desconocido',
    user: 'Usuario',
    notifications: 'Notificaciones',
  },
  theme: {
    light: 'Modo claro',
    dark: 'Modo oscuro',
  },
  auth: {
    login: 'Iniciar sesión',
    logout: 'Cerrar sesión',
    email: 'Correo electrónico',
    password: 'Contraseña',
    loginButton: 'Entrar',
    invalidCredentials: 'Credenciales inválidas',
    loginSuccess: 'Inicio de sesión exitoso',
    logoutSuccess: 'Cierre de sesión exitoso',
  },
  menu: {
    dashboard: 'Panel de control',
    groups: 'Grupos',
    companies: 'Empresas',
    users: 'Usuarios',
    sessions: 'Sesiones',
    logs: 'Registros',
    config: 'Configuración',
    systemGalatea: 'Sistema Galatea',
    dicionarioDados: 'Diccionario de Datos',
    dicionarioThor: 'Diccionario Thor',
  },
  groups: {
    title: 'Grupos de Empresas',
    new: 'Nuevo Grupo',
    edit: 'Editar Grupo',
    name: 'Nombre',
    description: 'Descripción',
    uuid: 'UUID',
    generateUuid: 'Generar nuevo UUID',
    enforceLimit: 'Aplicar límite de accesos simultáneos',
    enforceLimitShort: '¿Aplicar límite?',
    enforceLimitHint: 'Active para limitar el número de sesiones simultáneas por usuario en todas las empresas del grupo.',
    limitPerUser: 'Límite de sesiones por usuario',
    limitPerUserHint: 'Deje en blanco para ilimitado. Proporcione un número entero mayor o igual a cero.',
    limitPerUserPositive: 'El límite debe ser un número entero mayor o igual a cero.',
    limitUnlimited: 'Sin límite',
    permissiveLimit: 'Permitir exceder límite en casos especiales',
    permissiveLimitShort: '¿Permisivo?',
    permissiveLimitHint: 'Cuando está activado, el sistema permite superar el límite definido en situaciones controladas.',
    createSuccess: '¡Grupo creado con éxito!',
    updateSuccess: '¡Grupo actualizado con éxito!',
    deleteSuccess: '¡Grupo eliminado con éxito!',
    deleteConfirm: '¿Está seguro de que desea eliminar este grupo?',
    deleteWarning: 'Esta acción no se puede deshacer.',
    searchPlaceholder: 'Buscar por nombre o descripción...',
    noResults: 'No se encontraron grupos',
    noData: 'No hay grupos registrados',
  },
  companies: {
    title: 'Empresas',
    new: 'Nueva Empresa',
    edit: 'Editar Empresa',
    name: 'Nombre',
    cnpj: 'CNPJ',
    database: 'Base de Datos',
    ip: 'IP/Host',
    group: 'Grupo',
    status: 'Estado',
    createSuccess: '¡Empresa creada con éxito!',
    updateSuccess: '¡Empresa actualizada con éxito!',
    deleteSuccess: '¡Empresa eliminada con éxito!',
    deleteConfirm: '¿Está seguro de que desea eliminar esta empresa?',
    deleteWarning: 'Esta acción no se puede deshacer.',
    searchPlaceholder: 'Buscar por nombre, CNPJ o base de datos...',
    noResults: 'No se encontraron empresas',
    noData: 'No hay empresas registradas',
  },
  users: {
    title: 'Usuarios',
    edit: 'Editar Usuario',
    name: 'Nombre',
    email: 'Correo electrónico',
    accessLevel: 'Nivel de Acceso',
    updateSuccess: '¡Usuario actualizado con éxito!',
    linkCompanies: 'Gestionar Empresas',
    linkCompaniesTitle: 'Gestionar Empresas - {{name}}',
    linkedCompanies: 'Empresas Vinculadas',
    availableCompanies: 'Empresas Disponibles',
    link: 'Vincular',
    unlink: 'Desvincular',
    noLinkedCompanies: 'Ninguna empresa vinculada',
    allLinked: 'Todas las empresas ya están vinculadas',
    searchPlaceholder: 'Buscar por nombre o correo electrónico...',
    noResults: 'No se encontraron usuarios',
    noData: 'No hay usuarios registrados',
    emailCannotBeChanged: 'El correo electrónico no puede ser cambiado',
    userActive: 'Usuario Activo',
  },
  sessions: {
    title: 'Sesiones de Usuarios',
    selectUser: 'Seleccione un usuario',
    activeSessions: 'Sesiones Activas',
    activeSessionsCount: 'Sesiones Activas: {{valid}} de {{total}}',
    deviceId: 'ID del Dispositivo',
    deviceName: 'Nombre del Dispositivo',
    expiresAt: 'Expira en',
    createdAt: 'Creado en',
    revoke: 'Revocar',
    revokeAll: 'Revocar Todas',
    revokeSuccess: '¡Sesión revocada con éxito!',
    revokeAllSuccess: '¡Todas las sesiones han sido revocadas!',
    valid: 'Válida',
    revoked: 'Revocada',
    noSessions: 'No se encontraron sesiones',
  },
  accessLevels: {
    superAdmin: 'Super Administrador',
    administrator: 'Administrador',
    manager: 'Gerente',
    supervisor: 'Supervisor',
    operator: 'Operador',
    defaultUser: 'Usuario Estándar',
  },
  context: {
    selectTitle: 'Seleccionar el Modo de Actuación',
    selectSubtitle: 'Elija cómo desea actuar en el sistema',
    changeTitle: 'Cambiar Contexto de Actuación',
    modeOfAction: 'Modo de Actuación',
    superAdmin: 'Super Administrador',
    superAdminDescription: 'Acceso total al sistema (gestión de grupos, empresas, respaldos, configuraciones globales)',
    administrator: 'Administrador',
    administratorDescription: 'Acceso administrativo en una empresa específica (seleccione la empresa)',
    user: 'Usuario de la Empresa',
    userDescription: 'Acceso como usuario común de una empresa específica',
    company: 'Empresa',
    companyRequired: 'Empresa *',
    selectCompany: 'Seleccione una empresa',
    noCompanyAvailable: 'Ninguna empresa disponible para selección.',
    continue: 'Continuar',
    changeContext: 'Cambiar Contexto',
    selectMode: 'Seleccione un modo de actuación',
    selectCompanyError: 'Seleccione una empresa',
    saveError: 'Error al guardar contexto',
    loadError: 'Error al carregar contexto del usuario',
    changeLanguage: 'Cambiar idioma',
    switchContextTooltip: 'Cambiar contexto de actuación',
  },
  config: {
    title: 'Configuración',
    subtitle: 'Seleccione un módulo de configuración para continuar.',
    appearanceTitle: 'Apariencia',
    appearanceSubtitle: 'Elija el tema visual y el modo claro/oscuro.',
    options: {
      appearance: {
        title: 'Apariencia',
        description: 'Elija el tema visual y el modo claro/oscuro.',
      },
      branding: {
        title: 'Branding',
        description: 'Logo del encabezado y marca de agua de fondo.',
      },
      system: {
        title: 'Parámetros del Sistema',
        description: 'Gestione la configuración global de la plataforma Galatea (próximamente).',
        comingSoon: 'Próximamente',
      },
      dicionario: {
        title: 'Documentación Thor',
        description: 'Visualice y actualice la documentación de las tablas y columnas de las bases de datos Thor.',
      },
      open: 'Abrir',
    },
    sistemaGalatea: {
      title: 'Sistema Galatea',
      subtitle:
        'Esta área está en desarrollo. Pronto podrá gestionar recursos centrales de la plataforma Galatea desde aquí.',
    },
    dicionarioThor: {
      title: 'Documentación Thor',
      subtitle: 'Visualice las columnas documentadas de las bases de datos Thor.',
      searchPlaceholder: 'Buscar por tabla, columna o descripción...',
      error: 'Error al cargar los datos del diccionario.',
      empty: 'No se encontraron registros.',
      table: 'Tabla',
      column: 'Columna',
      type: 'Tipo',
      length: 'Tamaño',
      decimals: 'Decimales',
      statusColumn: 'Estado',
      description: 'Descripción',
      tableFilter: 'Filtro por tabla',
      tablePlaceholder: 'Ej.: clis, alternativas',
      columnFilter: 'Filtro por columna',
      columnPlaceholder: 'Ej.: cdcliente, dscoluna',
    },
  },
  themePresets: {
    'galatea-navy': { name: 'Galatea Azul Marino', recommendation: 'Administración General' },
    'emerald-warehouse': { name: 'Almacén Esmeralda', recommendation: 'WMS / Inventario' },
    'taxation-gold': { name: 'Fiscal Dorado', recommendation: 'Impuestos / ICMS / IPI' },
    'bpa-cyber': { name: 'BPA Cyber', recommendation: 'Automatización e IA' },
    'slate-industrial': { name: 'Pizarra Industrial', recommendation: 'Operaciones de Larga Duración' },
    'deep-oceanic': { name: 'Océano Profundo', recommendation: 'Logística y Fletes' },
    'ruby-accounting': { name: 'Contabilidad Rubí', recommendation: 'Finanzas / Auditoría' },
    'amber-logistics': { name: 'Ámbar Logística', recommendation: 'Envíos / Seguimiento' },
    'nordic-frost': { name: 'Escarcha Nórdica', recommendation: 'Informes de Gestión' },
    'midnight-tech': { name: 'Tecnología Medianoche', recommendation: 'Modo Dev / Usuarios Avanzados' },
    'coffee-bean': { name: 'Grano de Café', recommendation: 'Compras e Insumos' },
    'vibrant-violet': { name: 'Violeta Vibrante', recommendation: 'CRM y Ventas' },
    'forest-edge': { name: 'Borde del Bosque', recommendation: 'Sostenibilidad' },
    'electric-blue': { name: 'Azul Eléctrico', recommendation: 'Monitoreo en Tiempo Real' },
    'sunset-orange': { name: 'Naranja Atardecer', recommendation: 'Gestión de Riesgo' },
    'steel-grey': { name: 'Gris Acero', recommendation: 'Maestros Generales' },
    'teal-serenity': { name: 'Serenidad Turquesa', recommendation: 'RR. HH. y Colaboradores' },
    'royal-purple': { name: 'Púrpura Real', recommendation: 'Dashboards de Dirección' },
    'clay-terracotta': { name: 'Arcilla Terracota', recommendation: 'Piso de Fábrica' },
    'high-contrast': { name: 'Alto Contraste', recommendation: 'Accesibilidad / Baja Visión' },
  },
}
